import React from 'react';
import { HandshakeIcon, EyeIcon, UsersIcon } from 'lucide-react';
import { Section } from '../ui/Section';
import { Reveal } from '../ui/Reveal';
import { VCARS_LOGO } from '../../data/brand';
const valores = [{
  icon: HandshakeIcon,
  title: 'Compromiso',
  text: 'Te acompañamos en todo el proceso de compra.'
}, {
  icon: EyeIcon,
  title: 'Transparencia',
  text: 'Información clara de cada unidad, sin letra chica.'
}, {
  icon: UsersIcon,
  title: 'Asesoramiento cercano',
  text: 'Opciones según tus ingresos y posibilidades.'
}];
export function QuienesSomos() {
  return <Section id="quienes-somos" className="bg-surface" data-id="element-379" data-mp="2nrha10vd420p">
      <Reveal data-id="element-380" data-mp="2nqo7yd7cm0ow">
        <div className="overflow-hidden rounded-3xl border border-neon/35 bg-surface2/30 p-7 backdrop-blur-md md:p-12" style={{
        boxShadow: '0 0 60px -30px rgba(31,123,255,0.85)'
      }} data-id="element-381" data-mp="2nq67139qqyan">
          <div className="grid gap-10 lg:grid-cols-[1.25fr_1fr] lg:gap-16" data-id="element-382" data-mp="33cueqrx4nc7">
            <div data-id="element-383" data-mp="7ys2t375pr18">
              <div className="flex items-center gap-3" data-id="element-384" data-mp="82fwc2clqdfy">
                <img src={VCARS_LOGO} alt="" aria-hidden="true" className="h-11 w-11 rounded-full object-cover ring-1 ring-neon/40" data-id="element-385" data-mp="15kxaqybbrt8q" />
                <h2 className="text-3xl font-extrabold leading-[1.1] tracking-tight text-white md:text-[42px]" data-id="element-386" data-mp="wjqsokt12add">
                  ¿Quiénes somos?
                </h2>
              </div>

              <p className="mt-6 text-base leading-relaxed text-white/85 md:text-[17px]" data-id="element-387" data-mp="mnw1v2enh8zi">
                VCARS es una empresa dedicada a la venta de autos usados seleccionados y
                vehículos 0km. Nuestro objetivo es brindarle a cada cliente una atención
                100% personalizada, acompañándolo en todo el proceso de compra para
                encontrar el auto ideal según sus necesidades, ingresos y posibilidades.
              </p>
              <p className="mt-4 text-base leading-relaxed text-mist" data-id="element-388" data-mp="3v37go53jve19">
                Trabajamos con compromiso, transparencia y asesoramiento cercano,
                buscando siempre opciones que se adapten a cada persona, tanto en precio
                como en financiación, permuta o forma de entrega.
              </p>
            </div>

            <ul className="grid content-start gap-3" data-id="element-389" data-mp="3bip02f6gimft">
              {valores.map(({
              icon: Icon,
              title,
              text
            }) => <li key={title} className="flex gap-3.5 rounded-2xl border border-line bg-ink/50 p-5" data-id="element-390" data-mp="3gibcimegnynk">
                  <span className="mt-0.5 grid h-9 w-9 shrink-0 place-items-center rounded-lg bg-neon/12 text-neon" data-id="element-391" data-mp="czrxilksmpap">
                    <Icon className="h-[18px] w-[18px]" aria-hidden="true" data-id="element-392" data-mp="3uf8ar8wwsieh" />
                  </span>
                  <div data-id="element-393" data-mp="3848ssfmfmcx">
                    <h3 className="text-[15px] font-bold text-white" data-id="element-394" data-mp="37m2t435ptrt">{title}</h3>
                    <p className="mt-1 text-[13.5px] leading-relaxed text-mist" data-id="element-395" data-mp="qxq3p3oynff4">{text}</p>
                  </div>
                </li>)}
            </ul>
          </div>
        </div>
      </Reveal>
    </Section>;
}